import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class ExperienceModel extends BaseModel {

    constructor() {
        super({
                name: "experience",
                tableName: 'experience',
                label: "experience",
                /*display_key: 'fullname',
                default_order: { key: 'updated_at', direction: 'asc' } */},
            {
            
                id  : {
                    name: 'id',
                    type: "Uuid",
                    label: 'Hình anh',
                    sortable: false,
                    width : 8,
                },
                ordinal  : {
                  name: 'ordinal',
                  type: "Int",
                  label: 'Hình anh',
                  width : 8,
              },
              deleted: {
                name: "deleted",
                label: "Xóa",
                type: "Checkbox",
                display: false
            }
        },)
    }

}